import clsx from 'clsx';

import { store } from "../../Context/Store";
import { searchItemStyle } from "./style";
import { Box, Grid, Typography } from "@material-ui/core";
import { useContext, useEffect, useRef, useState } from "react";

const SearchItem = (props) => {
  const context = useContext(store)
  const { dispatch } = context;

  const [IsLongText, setIsLongText] = useState(0);
  const [hoverOnMe, sethoverOnMe] = useState(false);

  const classes = searchItemStyle({ over: IsLongText });

  const handleSelectAddress = (e) => {
    dispatch({ type: 'SET_LATLNG', latlng: e.currentTarget.dataset.latlng.split(',') })
    dispatch({ type: 'SET_ADDRESS', address: props.address.address })
  };

  const Div = useRef(null)

  useEffect(() => {
    if (Div) {
      if (Div.current.clientWidth > 377)
        setIsLongText(Div.current.clientWidth - 370)
    }
  }, [Div]);


  return (
    <Grid
      data-latlng={[props.address.latitude, props.address.longitude]}
      onClick={(e) => handleSelectAddress(e)}
      onMouseOver={(e) => sethoverOnMe(true)}
      onMouseLeave={(e) => sethoverOnMe(false)}
      className={classes.address}
      item
    // zeroMinWidth
    >
      <Box
        className={classes.addressText}
      // noWrap
      >
        <Typography className={clsx(classes.item, (IsLongText && hoverOnMe) && classes.moveItem)} ref={Div}>
          {props.address.address}
        </Typography>
      </Box>
    </Grid>
  );
};

export default SearchItem;
